import { Location } from '../model/location.js';
import { StatusDisplayItem } from '../index.js';

export interface ObjectWithCount {
	count: number;
}

export interface ObjectWithCanonicalString {
	canonicalString: string;
}

export interface TagWithCount extends ObjectWithCount {
	tag: string;
}

export interface TagWithCountAndCanonicalString
	extends TagWithCount,
		ObjectWithCanonicalString {}

export interface LocationWithCount extends ObjectWithCount {
	location: Location;
}
export interface LocationWithCountAndCanonicalString
	extends LocationWithCount,
		ObjectWithCanonicalString {}

export interface SectorWithCount extends ObjectWithCount {
	sector: string;
	parentSector?: string;
	subSectors?: string[];
}

export interface SectorWithCountAndCanonicalString
	extends SectorWithCount,
		ObjectWithCanonicalString {}

export interface SectorWithCountIdCanonicalString
	extends SectorWithCount,
		ObjectWithCanonicalString {
	sectorId: string;
	parentSectorId: string;
	displayName: string;
}

/**
 * Contains the menu options for the sector-with-children-dropown that
 * is used for any filter options that need to be grouped by sector,
 * e.g. subsector or development stage
 */
export interface SectorWithChildOptions {
	sectorOrOption: string;
	parentSector: string;
	children?: string[];
	count?: number;
}

export interface StatusWithCount extends ObjectWithCount {
	statusItem: StatusDisplayItem;
}

export function compareItemsWithCanonicalString(
	l1: ObjectWithCanonicalString | string,
	l2: ObjectWithCanonicalString | string
): boolean {
	if (l1 === null || l1 === undefined) {
		return l2 === null || l2 === undefined;
	}
	if (l2 === null || l2 === undefined) {
		return false;
	}

	const loc1 = typeof l1 === 'string' ? l1 : l1.canonicalString;
	const loc2 = typeof l2 === 'string' ? l2 : l2.canonicalString;
	return loc1.toLowerCase() === loc2.toLowerCase();
}
